// extracted by mini-css-extract-plugin
module.exports = {"tabHeading":"BosPendingPage_tabHeading__3a7gb","container":"BosPendingPage_container__2GU2z"};